import React from 'react';
import { MENU_LIST } from '../../constants/menu.constant';
import MenuScreen from '../MenuScreen/MenuScrren';

const MainMenu = ({isLimited}) => (
  <MenuScreen title="PAGRINDINIS MENIU" list={MENU_LIST(isLimited)} />
);

export default MainMenu;
